
@let isAlert =_orderWizardService.orderWizard$()?.step01?.pricingSummary?.isAmountAlert!;
<div 
    class="py-[1rem] px-[1rem] text-white  rounded-md flex items-start gap-[5px]"
        [ngClass]="[
            isAlert  ? 'bg-primary-500' : 'bg-secondary-300',
            isAlert  ? 'border border-primary-800' : 'bg-secondary-500'
            ]">
    <i   
        class=" text-[20px] mt-[2px]"
        [ngClass]="[isAlert  ? 'ri-alarm-warning-line' : 'ri-shield-check-line']">
    </i>

    <div>
        <!-- i18n: The total amount must be between -->
        {{ 'i18n.app.features.pages.order.wizard.step_01.summary.alert.div_01' | translate }}
        <span class="font-semibold">
            {{ _orderWizardService.orderWizard$()?.step01?.pricingSummary?.minAmount }}
        </span>
        <!-- i18n: € and -->
        {{ 'i18n.app.features.pages.order.wizard.step_01.summary.alert.div_02' | translate }}
        <span class="font-semibold">
            {{ _orderWizardService.orderWizard$()?.step01?.pricingSummary?.maxAmount }}
        </span>
        <!-- i18n: fees included -->
        {{ 'i18n.app.features.pages.order.wizard.step_01.summary.alert.div_03' | translate }}
    </div>
</div>

@if(isAlert){
    <div class="p-10">
        <corp-range-bar
            [min]="-800"
            [max]="4000"
            [minThreshold]="_orderWizardService.orderWizard$()?.step01?.pricingSummary?.minAmount!"
            [maxThreshold]="_orderWizardService.orderWizard$()?.step01?.pricingSummary?.maxAmount!"
            [value]="_orderWizardService.orderWizard$()?.step01?.pricingSummary?.total!"
            
            >
        </corp-range-bar>
    </div>
} 

